/* Engagement telemetry for the corporate services page — observation only.

   Answers "how far do visitors get before they leave?" per device, which GA4's
   single 90% scroll event cannot. Every milestone is its own event NAME
   (corp_screens_2, corp_view_gallery_events, corp_email_focus…) because event
   names are reportable by device/source immediately, while event parameters
   need GA4 custom dimensions registered first.

   Boundaries: nothing here is a conversion or key event. Lead success stays
   with corporate-proposal-tracking.js and its Worker. No PII is read: the email
   value is never touched. Analytics must never interrupt the page. */
(function () {
  'use strict';
  if (window.__bbCorporateEngagement) return;
  window.__bbCorporateEngagement = true;

  var GA_MEASUREMENT_ID = 'G-WWPNKDJRYH';
  var PREFIX = 'corp_';
  var SCREEN_MILESTONES = [1, 2, 4, 8, 16];
  var PERCENT_MILESTONES = [25, 50, 75, 90];
  var ENGAGED_SECONDS = [10, 30, 60];
  var SCROLL_START_PX = 40;
  var MAX_SECTION_EVENTS = 12;
  var CONSENT_RETRY_LIMIT = 12;
  var CONSENT_RETRY_DELAY_MS = 500;
  /* Mouseflow tags make recordings and heatmaps filterable by behaviour. */
  var MOUSEFLOW_TAGS = {
    box_shown: 1, email_focus: 1, email_submit: 1, see_work_click: 1,
    form_start: 1, form_submit_full: 1, screens_4: 1, view_proposal: 1
  };

  var scope = document.querySelector('.corp-scope');
  if (!scope || (window.Shopify && window.Shopify.designMode)) return;

  var startedAt = Date.now();
  var sent = {};
  var queue = [];
  var consentTries = 0;
  var retryTimer = null;
  var maxDepthPx = 0;

  function deviceClass() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    return width < 768 ? 'mobile' : width < 1100 ? 'tablet' : 'desktop';
  }

  function pageVariant() {
    try {
      var view = new URLSearchParams(window.location.search).get('view') || 'default';
      return view.replace(/[^a-z0-9_-]/gi, '').slice(0, 40) || 'default';
    } catch (_error) {
      return 'default';
    }
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return null;
      return privacy.analyticsProcessingAllowed() === true;
    } catch (_error) {
      return null;
    }
  }

  function deliver(item) {
    try {
      window.gtag('event', PREFIX + item.name, {
        send_to: GA_MEASUREMENT_ID,
        device_class: deviceClass(),
        page_variant: pageVariant(),
        depth_px: item.depthPx,
        seconds_on_page: item.seconds
      });
    } catch (_error) {}
    try {
      if (MOUSEFLOW_TAGS[item.name] && window._mfq && typeof window._mfq.push === 'function') {
        window._mfq.push(['tag', 'corp:' + item.name]);
      }
    } catch (_error) {}
  }

  /* Fail closed: events wait for an explicit "analytics allowed" and a loaded
     gtag; a refusal or a timeout drops them. */
  function flush() {
    var allowed = analyticsAllowed();
    if (allowed === false) { queue = []; return; }
    if (allowed === null || typeof window.gtag !== 'function') {
      if (retryTimer !== null) return;
      if (consentTries >= CONSENT_RETRY_LIMIT) { queue = []; return; }
      consentTries += 1;
      retryTimer = window.setTimeout(function () { retryTimer = null; flush(); }, CONSENT_RETRY_DELAY_MS);
      return;
    }
    while (queue.length) deliver(queue.shift());
  }

  function track(name) {
    if (sent[name]) return;
    sent[name] = true;
    queue.push({
      name: name,
      depthPx: Math.round(maxDepthPx),
      seconds: Math.round((Date.now() - startedAt) / 1000)
    });
    flush();
  }

  /* ---- Depth: first scroll, screens scrolled, percent of page ---- */
  var depthQueued = false;
  function measureDepth() {
    depthQueued = false;
    var y = window.scrollY || window.pageYOffset || 0;
    var viewport = window.innerHeight || 1;
    var scrollable = Math.max(1, document.documentElement.scrollHeight - viewport);
    if (y > maxDepthPx) maxDepthPx = y;
    if (y >= SCROLL_START_PX) track('scroll_start');
    SCREEN_MILESTONES.forEach(function (screens) {
      if (y >= screens * viewport) track('screens_' + screens);
    });
    PERCENT_MILESTONES.forEach(function (percent) {
      if ((y / scrollable) * 100 >= percent) track('depth_' + percent);
    });
  }
  window.addEventListener('scroll', function () {
    if (depthQueued) return;
    depthQueued = true;
    window.requestAnimationFrame(measureDepth);
  }, { passive: true });

  /* ---- Section views: a section counts once a third of the viewport shows it ---- */
  function sectionKey(section) {
    var suffix = String(section.id || '').split('__')[1] || '';
    return suffix.toLowerCase().replace(/[^a-z0-9_]/g, '_').slice(0, 28);
  }
  if ('IntersectionObserver' in window) {
    var sections = Array.prototype.slice
      .call(document.querySelectorAll('[id^="shopify-section-template"]'))
      .filter(sectionKey)
      .slice(0, MAX_SECTION_EVENTS);
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        sectionObserver.unobserve(entry.target);
        track('view_' + sectionKey(entry.target));
      });
    }, { rootMargin: '0px 0px -33% 0px', threshold: 0 });
    sections.forEach(function (section) { sectionObserver.observe(section); });
  }

  /* ---- Hero box: on mobile it only appears once the visitor scrolls ---- */
  var well = document.querySelector('[data-corp-well]');
  if (well) {
    var motionRoot = well.closest('.corp-mobile-motion');
    if (!motionRoot) {
      track('box_shown');
    } else if ('MutationObserver' in window) {
      var boxObserver = new MutationObserver(function () {
        if (!well.classList.contains('is-mobile-interactive')) return;
        boxObserver.disconnect();
        track('box_shown');
      });
      boxObserver.observe(well, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ---- Interactions ---- */
  document.addEventListener('bb:corporate-quick:submit', function () { track('email_submit'); });
  document.addEventListener('bb:corporate-quick:invalid', function () { track('email_invalid'); });
  document.addEventListener('bb:corporate-quick:see-work', function () { track('see_work_click'); });

  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-corp-quick]') && target.tagName === 'INPUT') track('email_focus');
    else if (target.closest('[data-corp-proposal] form') && /^(INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
      track('form_start');
    }
  });

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('.corp-scope a[href], .bb-answer__cta') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('tel:') === 0) return track('call_click');
    if (href.indexOf('sms:') === 0) return track('text_click');
    if (href.indexOf('mailto:') === 0) return track('mailto_click');
    if (href === '#proposal' || href === '#corporate-inquiry') {
      var section = link.closest('[id^="shopify-section-template"]');
      track('cta_' + ((section && sectionKey(section)) || 'page'));
    }
  });

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (details && details.open && details.closest && details.closest('[data-corp-proposal]')) track('form_details_open');
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest || !form.closest('[data-corp-proposal]')) return;
    var entry = form.querySelector('[name="contact[Entry point]"]');
    /* The quick box submits through this same form; count that path once. */
    if (!entry || !entry.value) track('form_submit_full');
  }, true);

  /* ---- Engaged time: visible seconds only ---- */
  var visibleMs = 0;
  var visibleSince = document.visibilityState === 'hidden' ? null : Date.now();
  function visibleSeconds() {
    return (visibleMs + (visibleSince === null ? 0 : Date.now() - visibleSince)) / 1000;
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (visibleSince !== null) visibleMs += Date.now() - visibleSince;
      visibleSince = null;
    } else if (visibleSince === null) {
      visibleSince = Date.now();
    }
  });
  var engagedTimer = window.setInterval(function () {
    var seconds = visibleSeconds();
    ENGAGED_SECONDS.forEach(function (mark) { if (seconds >= mark) track('engaged_' + mark + 's'); });
    if (seconds >= ENGAGED_SECONDS[ENGAGED_SECONDS.length - 1]) window.clearInterval(engagedTimer);
  }, 1000);

  document.addEventListener('visitorConsentCollected', flush);
  measureDepth();
})();
